<template>
  <b-row class="campaign-dashboard">
    <b-col cols="12" class="d-flex flex-row justify-content-center align-items-center my-5" v-if="!dashboard">
      <b-spinner type="grow" variant="primary"/>
    </b-col>
    <b-col cols="12" class="px-md-4 pt-1" v-else-if="dashboard">

      <!-- Test Row - Start -->
      <b-row v-if="!isMyDentist">
        <!-- Test Col - Start -->
        <b-col :class="{ 'pb-5': collectiveGoal }">
          <div :class="{ 'mb-sm-5': !collectiveGoal, 'my-3 bg-primary-a1 p-4': true, 'h-100': collectiveGoal }">

          <div class="d-flex justify-content-between" :class="{ 'align-items-center h-100': collectiveGoal }">
            <div v-if="!isEY && !isHSBCDemo">
              <h3 class="font-weight-normal">
              <strong v-if="hasReferralsEnabled">{{ $t('dashboard.welcome-greeting.welcome-campaign-first-line') }}</strong>
              <strong v-else>👋 Welcome to Real Links - our social advocacy platform!
                Please support our employer branding efforts by sharing content with your social media connections!</strong>
              <br>
              <span :class="{ 'd-block mt-3' : collectiveGoal }">
                {{ $t('dashboard.welcome-greeting.welcome-campaign-second-line') }}
              </span>
              </h3>
            </div>
            <div v-else-if="isHSBCDemo">
              <h3 class="font-weight-normal">
                <strong>👋 Welcome to Real Links - our referral and advocacy platform!</strong>
              </h3>
            </div>
            <div v-else>
              <h3 class="font-weight-normal">
              <strong>👋 Welcome to the EY Ambassador Platform.</strong>
              <br>
              <span :class="{ 'd-block mt-3' : collectiveGoal }">
                Share content with your network & you could win a HelloFresh Box
              </span>
              </h3>
            </div>
            <div v-if="isInforma">
              <b-button @click="toggleWelcomeIcon" class="px-2" variant="outline-primary" size="sm" v-b-toggle.learn-more>
                <font-awesome-icon v-if="isWelcomeIconDown" icon="chevron-up" size="sm"/>
                <font-awesome-icon v-else icon="chevron-down" size="sm"/>
              </b-button>
            </div>
          </div>

          <b-collapse v-if="isInforma" id="learn-more" visible>
            <b-card>
              <!-- <h4><strong>The Perks</strong></h4>
              <h4>Our reward platform is stocked with over 30,000 vouchers across the world, to give you the ultimate choice in rewards.</h4>
              <ul>
                <li>
                  <h4>For every referral you make, and job you share with your network, you will receive a ticket to our monthly raffle where you can win big prizes to be spent in our reward shop.</h4>
                </li>
                <li>
                  <h4>For every application and interview that comes from your job sharing, we will reward you with additional tokens to be spent in the reward shop.</h4>
                </li>
              </ul>
              <br>
              <h4>And the good news is - <strong>if hired - you will get a success fee and additional perks!</strong></h4> -->

              <h4><strong>The Perks</strong></h4>
              <p>Our reward platform is stocked with over 30,000 vouchers across the world, to give you the ultimate choice in rewards.</p>
              <ul>
                <li>For every referral or recommendation you make, every time an application is submitted, an interview takes place, or a hire is created, because of your personal recommendation, you’ll receive tokens which can be spent in the reward shop.</li>
                <li>Use the ‘Share’ button to share a job internally to your peers and Colleagues using a unique code.</li>
                <li>Use the ‘Apply’ button to personally apply to any jobs that you see which are of interest to you!</li>
              </ul>
              <p>* The Informa referral bonus does not apply to this campaign (as colleagues are already part of our organization). Instead, you have the chance to earn yourself vouchers and pre-paid gift cards across thousands of brands!</p>
            </b-card>
          </b-collapse>
          </div>
        </b-col>

        <!-- Test Col - End -->
        <b-col cols="6" class="mb-3" v-if="collectiveGoal">
          <csr-initiative
            class="my-3"
            :csrInitiative="collectiveGoal"
            :isDashboard="true"
            :monthlyTotalPoints="dashboard.leaderboardStatsInPeriod ? dashboard.leaderboardStatsInPeriod.totalEvents : 0"
            :leaderboardMonthlyPoints="dashboard.leaderboardStatsInPeriodMonthly ? dashboard.leaderboardStatsInPeriodMonthly.map(({ totalEvents }) => totalEvents) : [0]"
          />
        </b-col>
      </b-row>
      <!-- Test Row - End -->

      <!-- only for eXPD8 for now – don’t want to enable it for everyone without knowing -->
      <b-row v-if="enableDashboardCards && Array.isArray(company.dashboardCards) && company.dashboardCards.length > 0">
        <b-col v-for="(card, i) in Array.isArray(company.dashboardCards) ? company.dashboardCards : []"
          :key="i"
          sm="12"
          md="12"
          :lg="company.dashboardCards.length <= 3 ? 12 / company.dashboardCards.length : 4"
          :xl="company.dashboardCards.length <= 3 ? 12 / company.dashboardCards.length : 4"
          class="my-2"
        >
          <welcome-card :card="card" />
        </b-col>
      </b-row>

      <b-row v-if="!isEY && hasReferralsEnabled && hasContentEnabled">
        <b-col cols="12" md="8">
          <h3>{{ $t('dashboard.titles.job-score-board') }}</h3>
          <b-card class="my-3">
            <score-block v-bind="jobScorecard"/>
          </b-card>
        </b-col>
        <b-col cols="12" md="4">
          <h3>{{ $t('dashboard.titles.content-score-board') }}</h3>
          <b-card class="my-3">
            <score-block v-bind="contentScorecard"/>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else-if="!isEY && hasReferralsEnabled">
        <b-col cols="12" md="12">
          <h3>{{ $t('dashboard.titles.job-score-board') }}</h3>
          <b-card class="my-3">
            <score-block v-bind="jobScorecard"/>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else-if="!isEY && hasContentEnabled">
        <b-col cols="12" md="4">
          <h3>{{ $t('dashboard.titles.content-score-board') }}</h3>
          <b-card class="my-3">
            <score-block v-bind="contentScorecard"/>
          </b-card>
        </b-col>
      </b-row>

      <div class="my-3" v-if="dashboard && Array.isArray(dashboard.campaigns) && dashboard.campaigns.length">
        <h3>{{ $t('dashboard.titles.campaigns') }}</h3>
        <campaign-card class="mb-5" v-for="campaign in dashboard.campaigns" :key="campaign.id" :campaign="campaign"/>
      </div>
      <template v-else>
        <div class="my-3" v-if="dashboard && hasReferralsEnabled && Array.isArray(dashboard.jobs) && dashboard.jobs.length">
          <h3>{{ $t('dashboard.titles.jobs') }}</h3>
          <b-row class="card-deck">
            <b-col class="my-3" cols="12" sm="6" v-for="entry in dashboard.jobs.slice(0, 6)" :key="entry.id">
              <job-card class="m-0" :job="entry"/>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center align-items-center my-4">
            <b-btn :to="{ name: 'CampaignJobIndex' }" size="sm" variant="outline-primary">{{ $t('campaign.buttons.view_all_jobs') }}</b-btn>
          </div>
        </div>
        <div class="my-3" v-if="dashboard && hasContentEnabled && Array.isArray(dashboard.contentShares) && dashboard.contentShares.length && isContentShareToolEnabled">
          <h3>{{ $t('dashboard.titles.content') }}</h3>
          <b-row class="card-deck">
            <b-col class="my-3" cols="12" sm="6" md="4" v-for="entry in dashboard.contentShares.filter((content) => content.status === 'ACTIVE').slice(0, 6)" :key="entry.id">
              <content-card class="m-0" :entry="entry" :share-url="`${origin}/c/${entry.shareCode}${dashboard.trackingCode ? dashboard.trackingCode : ''}`"
                @trackShare="data => trackContentSharedEvent(entry, data)"/>
            </b-col>
          </b-row>
        </div>
      </template>

    </b-col>
    <!-- b-col cols="12" class="px-4 pt-1" v-else-if="dashboard && true">
      <event-room-modal :campaign="dashboard.campaigns[0]" />
    </b-col -->
  </b-row>
</template>

<script>
import _pick from 'lodash/pick';
import ms from 'ms';
import { mapRoot, mapPreferences } from '@src/mixins/root';
import DashboardQuery from '@/graphql/queries/CampaignsDashboard.gql';
import ScoreBlock from '@/components/campaign-dashboard/score-block';
import CampaignCard from '@/components/campaign-dashboard/campaign-card';
import CsrInitiative from '@/components/dashboard/CsrInitiative';
import JobCard from '@/components/campaign/job-card';
import EventRoomModal from '@/views/ReferralJam/EventRoomModal';
import ContentCard from '@/components/content-share/ContentCard';
import connectLinkedInForPosting from '@src/mixins/connectLinkedIn';
import scheduleLinkedInMixin from '@src/mixins/scheduleLinkedIn';
import WelcomeCard from '@/components/dashboard/Welcome-Card';

const { default: confetti } = process.env.VUE_ENV === 'client' ? require('canvas-confetti') : null;

export default {
  name: 'CampaignDashboard',
  components: {
    ScoreBlock,
    CampaignCard,
    JobCard,
    ContentCard,
    CsrInitiative,
    EventRoomModal,
    WelcomeCard
  },
  data: () => ({
    updateRefreshRate: '30s',
    isWelcomeIconDown: true,
  }),
  mixins: [
    scheduleLinkedInMixin, connectLinkedInForPosting
  ],
  apollo: {
    dashboard: {
      query: DashboardQuery,
      variables() {
        const beginningOfPeriod = new Date(2022, 3, 1);
        const { keys: jobScoreKeys } = this.jobScorecard;
        const { keys: contentScoreKeys } = this.contentScorecard;
        const { location, country } = this.userLocation || {};
        const latitude = this.user && this.user.geolocation ? this.user.geolocation.latitude : parseFloat(sessionStorage.getItem('latitude')) || null;
        const longitude = this.user && this.user.geolocation ? this.user.geolocation.longitude : parseFloat(sessionStorage.getItem('latitude')) || null;
        return {
          scorecardEvents: [ ...jobScoreKeys, ...contentScoreKeys, 'REFERRAL_SHARED', 'REFERRAL_VISITED' ],
          leaderboardStatsWhere: {
            after: beginningOfPeriod.toISOString(),
            eventName_in: [ 'JOB_SHARED', 'REFERRAL_SHARED' ],
          },
          pinJobsByExactLocation: !!location,
          pinJobsByCountry: !!country,
          pinExactLocationWhere: location ? {
            status: 'ACTIVE',
            customFields: [ { key: 'location', value: location } ],
          } : null,
          pinCountryWhere: country ? {
            status: 'ACTIVE',
            customFields: [ { key: 'country', value: country } ],
            ...{ NOT: location
              ? [ { customFields: [ { key: 'location', value: location } ] }, { isInternal: true } ]
              : [ { isInternal: true } ]
            },
          } : null,
          jobsOrderBy: latitude && longitude ? 'DISTANCE_ASC' : 'MOST_RELEVANT',
          latitude,
          longitude
        };
      },
      update({ company, user }) {
        /* eslint-disable object-property-newline */
        const { isEventOnlyMode } = this;
        const { jobAggs, dashboardCards, contentShares, rewards, leaderboardStatsInPeriodMonthly } = company;
        const { scorecard, campaigns, jobs, pinnedJobsByExactLocation, pinnedJobsByCountry } = user;
        const leaderboardStatsInPeriod = leaderboardStatsInPeriodMonthly[leaderboardStatsInPeriodMonthly.length - 1];
        console.log('RETURNING DASHBOARD');
        if (isEventOnlyMode && Array.isArray(campaigns)) {
          const currentUnix = (new Date()).getTime();
          const eventID = campaigns.reduce((r, { event }) => {
            if (r) return r;
            if (event && event.id && event.startDate && event.endDate && event.endDate >= currentUnix && event.startDate <= currentUnix) {
              return event.id;
            }
            return null;
          }, null);
          if (eventID) {
            this.$router.push({ name: 'EventRoom', params: { eventID } });
          }
        }

        // set tracking code for HelloFresh
        let trackingCode = null;
        if (Array.isArray(campaigns) && campaigns.length && campaigns[0] && campaigns[0].trackingCode) {
          trackingCode = `?${campaigns[0].trackingCode}`;
        }

        return { jobAggs, dashboardCards, rewards, campaigns, scorecard, jobs: [ ...(pinnedJobsByExactLocation || []), ...(pinnedJobsByCountry || []), ...(jobs || []) ].slice(0, 6),
          contentShares, leaderboardStatsInPeriod, leaderboardStatsInPeriodMonthly, trackingCode };
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: this.$t('dashboard.errors.failed-to-load') });
      },
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
      deep: true,
      throttle: ms('1s'),
    },
  },
  async mounted() {
    console.log({ company: this.company });
    if (this.$route.query && this.$route.query.callback) {
      const [ callback ] = this.$route.query.callback.split(':');
      try {
        switch (callback) {
          case 'connectedLinkedInForScheduling': {
            await this.connectedLinkedInForScheduling();
            break;
          }
          case 'connectLinkedInForPosting': {
            await this.connectLinkedInForPosting();
            break;
          }
        }
      } catch (err) {
        this.$log.error(err);
      }
    }
    if (this.$route.query && this.$route.query.campID && this.$route.query.compID) {
      try {
        sessionStorage.setItem('campID', this.$route.query.campID);
        sessionStorage.setItem('compID', this.$route.query.compID);
        await this.$root.captureLog({
          eventName: 'DASHBOARD_VISITED',
          user: { self: true },
          campaignComponent: { id: this.$route.query.compID },
          campaign: { id: this.$route.query.campID },
        });
        this.$router.replace({ query: {} });
      } catch (err) {
        this.$log.error(err);
      }
    }

    this.startUpdates();
  },
  beforeMount() {
    if (this.isEXPD8 &&
    navigator.geolocation &&
    (!(this.user && this.user.geolocation) ||
    !sessionStorage.getItem('latitude') ||
    !sessionStorage.getItem('longitude'))) {
      navigator.geolocation.getCurrentPosition(
        position => {
          sessionStorage.setItem('latitude', position.coords.latitude);
          sessionStorage.setItem('longitude', position.coords.longitude);
        },
        () => { console.warn('Geolocation failed'); });
    }
  },
  beforeDestroy() {
    this.stopUpdates();
  },
  metaInfo() {
    return {
      title: this.$t('navigation.dashboard'),
    };
  },
  events: {
    capturedLog({ eventName }) {
      if ([ 'JOB_SHARED', 'CONTENT_SHARED' ].includes(eventName)) {
        confetti({ particleCount: 150, spread: 180, zIndex: 1200 });
        if (this.$apollo.queries.dashboard) {
          this.$apollo.queries.dashboard.refresh();
        }
      }
    },
  },
  computed: {
    ...mapRoot([ 'origin', 'user', 'company', 'isRecruiter', 'isInforma', 'isTaylorAndFrancis', 'company', 'isEXPD8', 'isEY', 'isAssurant', 'isHSBCDemo', 'isDemoSite', 'isMyDentist' ]),
    ...mapPreferences([ 'isContentShareToolEnabled', 'isEventOnlyMode', 'enableDashboardCards' ]),
    jobScorecard() {
      const { scorecard } = this.dashboard || {};

      let normalisedScorecard = null;
      if (scorecard) {
        normalisedScorecard = {
          JOB_SHARED: (scorecard.JOB_SHARED || 0) + (scorecard.REFERRAL_SHARED || 0),
          SHARE_VISITED: (scorecard.SHARE_VISITED || 0) + (scorecard.REFERRAL_VISITED || 0),
          APPLICATION_CREATED: scorecard.APPLICATION_CREATED || 0,
          APPLICATION_INTERVIEW: scorecard.APPLICATION_INTERVIEW || 0,
          APPLICATION_HIRED: scorecard.APPLICATION_HIRED || 0,
        };
      }

      const labels = {
        JOB_SHARED: this.$t('dashboard.score-card.shares'),
        SHARE_VISITED: this.$t('dashboard.score-card.views'),
        APPLICATION_CREATED: this.$t('dashboard.score-card.applications'),
        APPLICATION_INTERVIEW: this.$t('dashboard.score-card.interviews'),
        APPLICATION_HIRED: this.$t('dashboard.score-card.hires'),
      };

      const keys = Object.keys(labels);

      return {
        keys,
        labels,
        values: {
          ...keys.reduce((start, key) => ({ ...start, [key]: 0 }), {}),
          ..._pick(normalisedScorecard, keys),
        },
      };
    },
    contentScorecard() {
      const { scorecard } = this.dashboard || {};

      const labels = {
        CONTENT_SHARED: this.$t('dashboard.score-card.shares'),
        CONTENT_SHARE_VISITED: this.$t('dashboard.score-card.views'),
      };

      const keys = Object.keys(labels);

      return {
        keys,
        labels,
        values: {
          ...keys.reduce((start, key) => ({ ...start, [key]: 0 }), {}),
          ..._pick(scorecard, keys),
        },
      };
    },
    collectiveGoal() {
      const { collectiveGoal } = this.company || {};
      if (collectiveGoal && collectiveGoal.status === 'ACTIVE') {
        return collectiveGoal;
      }
      return null;
    },
    userLocation() {
      const { sitePreferences, preferences } = this.company || {};
      const { pinJobsByLocation } = { ...sitePreferences, ...preferences };
      const { locationMap } = this.company;
      const { customFields } = this.user;
      const userLocation = pinJobsByLocation && locationMap && locationMap.locationField && Array.isArray(customFields)
        ? customFields.find(({ key }) => key === locationMap.locationField) : null;
      const { value: locationValue } = userLocation || {};
      const { location, country } = locationValue && Array.isArray(locationMap.locations)
        ? locationMap.locations.find(({ location }) => location === locationValue) : {};
      return { location, country };
    },
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    hasContentEnabled() {
      const { featuresEnabled } = this.sitePreferences || {};
      return (featuresEnabled || []).includes('content');
    },
    hasReferralsEnabled() {
      const { featuresEnabled } = this.sitePreferences || {};
      return (featuresEnabled || []).includes('referrals');
    },
  },
  methods: {
    startUpdates() {
      this.updateInterval && clearInterval(this.updateInterval);
      this.updateInterval = setInterval(() => this.$apollo.queries.dashboard.refresh(), ms(this.updateRefreshRate));
    },
    stopUpdates() {
      this.updateInterval && clearInterval(this.updateInterval);
    },
    toggleWelcomeIcon() {
      this.isWelcomeIconDown = !this.isWelcomeIconDown;
    }
  },
};
</script>

<style lang="scss">
.campaign-dashboard {
  h3 {
    font-size: 20px;
    font-weight: bold;
  }
  .block-title {
    text-transform: uppercase;
  }
  .upload-button {
    text-align: center;
    border-radius: 4px;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    h3 {
      display: inline-block;
    }
    p {
      margin-block-start: 0;
      margin-block-end: 0;

    }
    &.card {
      padding: 0.5em;
      .card-body {
        padding: 0.5em;
      }
    }
  }

  .welcome-block {
    h1 {
      line-height: 1.28;
      font-weight: 400;
    }
    &.row {
      margin-left: 0px;
      margin-right: 0px
    }
  }

  .welcome-block-height {
    height: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboards/Campaign.vue